export function withCalculatedColumnWidth(columns, bodyWidth) {
    var widthRemainder = bodyWidth;
    columns.forEach(function (config) {
        if (config.width) {
            widthRemainder = Math.max(widthRemainder - config.width, 0);
        }
    });
    var flexColumns = columns
        .map(function (item, index) { return Object.assign({}, item, { idx: index }); })
        .filter(function (item) { return !item.width; })
        .map(function (item) { return Object.assign({}, item, { flex: item.flex || 1 }); });
    var divider = flexColumns.reduce(function (acc, curr) {
        return acc + curr.flex;
    }, 0);
    var flexSizeUnit = Math.floor(widthRemainder / divider);
    var columnsWithCalculatedWidth = columns.map(function (config, colIndex) {
        var _a;
        var width = config.width;
        if (!width) {
            var flexCol = flexColumns.find(function (value) { return value.idx == colIndex; });
            var flex = (_a = flexCol === null || flexCol === void 0 ? void 0 : flexCol.flex) !== null && _a !== void 0 ? _a : 1;
            width = flex * flexSizeUnit;
        }
        var widthWithMinLimit = Math.max(width, config.minWidth || 0);
        return Object.assign({}, config, {
            width: Math.min(widthWithMinLimit, config.maxWidth || widthWithMinLimit)
        });
    });
    var widthSum = columnsWithCalculatedWidth.reduce(function (acc, curr) {
        return acc + curr.width;
    }, 0);
    var widthDiff = bodyWidth - widthSum;
    if (widthDiff > 0 && flexColumns.length) {
        var columnIndexWithMaxFlex_1 = 0;
        flexColumns.forEach(function (item, idx) {
            if (item.flex >= flexColumns[columnIndexWithMaxFlex_1].flex) {
                columnIndexWithMaxFlex_1 = idx;
            }
        });
        var originIndex = flexColumns[columnIndexWithMaxFlex_1].idx;
        columnsWithCalculatedWidth[originIndex].width =
            columnsWithCalculatedWidth[originIndex].width + widthDiff;
    }
    return columnsWithCalculatedWidth;
}
export function callWidthSum(acc, curr) {
    return acc + (curr.width || 0);
}
var scrollMeasureWrapperElement = null;
var scrollMeasureInnerElement = null;
export function getScrollBarWidth() {
    var scrollWidth = 0;
    if (!scrollMeasureWrapperElement || !scrollMeasureInnerElement) {
        scrollMeasureWrapperElement = document.createElement('div');
        scrollMeasureWrapperElement.style.cssText = "\n            position: fixed;\n            bottom: 100%; \n            left: 0; \n            background: transparent; \n            width: 50px; \n            height: 50px; \n            overflow: auto;\n        ";
        scrollMeasureInnerElement = document.createElement('div');
        scrollMeasureInnerElement.style.cssText = 'width: 100%; height: 60px;';
        scrollMeasureWrapperElement.appendChild(scrollMeasureInnerElement);
        document.body.appendChild(scrollMeasureWrapperElement);
    }
    scrollWidth = scrollMeasureWrapperElement.offsetWidth - scrollMeasureInnerElement.offsetWidth;
    return scrollWidth;
}
//# sourceMappingURL=utils.js.map